export default [
    {
        path: '/rent/v2/embed',
        name: 'embed',
        component: () => import('@/pages/travel/embed'),
        meta: { title: '定制游', requireAuth: true },
    }
]


// WEBPACK FOOTER //
// ./src/pages/travel/travel.js